import { render } from "./SmartForm.vue?vue&type=template&id=23ca2af9&lang=pug"
import script from "./SmartForm.vue?vue&type=script&lang=js"
export * from "./SmartForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__